import {
  computeMusteriTahsilatToplam,
  isGarantiDahilindeValue,
  isGarantiSartlariSaglanmadiValue,
  isBakimIslemTipi,
} from './musteriTahsilatHelper';

const BEDEL_DURUM_LABELS = {
  OnayBekliyor: 'Onay Bekliyor',
  Onaylandi: 'Onaylandı',
  HakediseAktarildi: 'Hakedişe Aktarıldı',
  Iptal: 'İptal',
};

function buildSatirlarFromRandevu(randevu) {
  const satirlar = [];
  for (const i of randevu?.yapilanIslemler || []) {
    const adet = Math.max(1, Number(i.adet) || 1);
    const fiyat = Number(i.fiyat) || 0;
    satirlar.push({
      tip: 'islem',
      aciklama: i.islemAdi || i.islemKodu || 'İşlem',
      adet,
      birimFiyat: fiyat,
      toplam: fiyat * adet,
    });
  }
  for (const i of randevu?.ilaveIslemler || []) {
    const adet = Math.max(1, Number(i.adet) || 1);
    const fiyat = Number(i.fiyat) || 0;
    satirlar.push({
      tip: 'ilave',
      aciklama: i.islemAdi || 'İlave işlem',
      adet,
      birimFiyat: fiyat,
      toplam: fiyat * adet,
    });
  }
  for (const p of randevu?.degistirilenParcalar || []) {
    const adet = Math.max(1, Number(p.adet) || 1);
    const fiyat = Number(p.fiyat) || 0;
    satirlar.push({
      tip: 'parca',
      aciklama: p.parcaAdi || p.parcaKodu || 'Parça',
      adet,
      birimFiyat: fiyat,
      toplam: fiyat * adet,
    });
  }
  return satirlar;
}

/**
 * AP randevu detay — Randevu Bedeli kartı gösterimi.
 * @param {object} appointment
 * @param {object|null} randevuBedeliDoc - fetchRandevuBedelleri kaydı
 */
export function resolveRandevuBedeliGosterim(appointment, randevuBedeliDoc = null) {
  if (!appointment) {
    return {
      kaynak: null,
      toplamTutar: null,
      durum: null,
      durumLabel: null,
      aciklama: null,
      satirlar: [],
      uyarilar: [],
      altEtiket: null,
    };
  }

  const islemTipi = appointment?.servisKaydi?.islemTipi
    ?? appointment?.servisKaydiId?.islemTipi
    ?? '';

  if (isGarantiSartlariSaglanmadiValue(appointment.garantiSartlariSaglanmadi)) {
    const tutar = appointment.servisBedeli != null
      ? Number(appointment.servisBedeli)
      : Number(appointment.musteriTahsilatToplam) || 0;
    return {
      kaynak: 'servisBedeli',
      toplamTutar: tutar,
      durum: null,
      durumLabel: null,
      aciklama: 'Garanti şartları sağlanmadığı için uygulanan servis bedeli',
      satirlar: [{
        tip: 'servisBedeli',
        aciklama: 'Servis bedeli (garanti şartları sağlanmadı)',
        adet: 1,
        birimFiyat: tutar,
        toplam: tutar,
      }],
      uyarilar: [
        'Müşteri kontrol listesi veya kurulum gereksinimlerini sağlamadığı için işlem garanti kapsamı dışında tamamlanmıştır.',
      ],
      altEtiket: 'Müşteri tahsilatı',
    };
  }

  const garantiDahilinde = isGarantiDahilindeValue(appointment.garantiDahilinde);
  const bedelDoc = randevuBedeliDoc;

  if (garantiDahilinde && bedelDoc) {
    const satirlar = (bedelDoc.satirlar || []).map((s) => {
      const adet = Math.max(1, Number(s.adet) || 1);
      const fiyat = Number(s.fiyat) || 0;
      return {
        tip: s.tip,
        aciklama: s.islemAdi || s.parcaAdi || s.aciklama || '—',
        adet,
        birimFiyat: fiyat,
        toplam: fiyat * adet,
      };
    });
    const yol = Number(bedelDoc.yolBedeli) || 0;
    if (yol > 0) {
      satirlar.push({
        tip: 'yol',
        aciklama: 'Yol bedeli',
        adet: 1,
        birimFiyat: yol,
        toplam: yol,
      });
    }
    return {
      kaynak: 'hakedis',
      toplamTutar: Number(bedelDoc.toplamTutar) || 0,
      durum: bedelDoc.durum || null,
      durumLabel: BEDEL_DURUM_LABELS[bedelDoc.durum] || bedelDoc.durum || null,
      aciklama: 'Fabrika → teknik servis hakediş bedeli',
      satirlar,
      uyarilar: [],
      altEtiket: 'Hakediş',
    };
  }

  const tahsilat = computeMusteriTahsilatToplam(appointment, islemTipi, appointment?.bakimOzeti);
  if (!garantiDahilinde && tahsilat > 0) {
    return {
      kaynak: 'musteriTahsilat',
      toplamTutar: tahsilat,
      durum: null,
      durumLabel: null,
      aciklama: isBakimIslemTipi(islemTipi)
        ? 'Bakım müşteri tahsilat tutarı'
        : 'Garanti harici müşteri tahsilat tutarı (işlem + parça)',
      satirlar: buildSatirlarFromRandevu(appointment),
      uyarilar: [],
      altEtiket: 'Müşteri tahsilatı',
    };
  }

  if (isBakimIslemTipi(islemTipi) && tahsilat > 0) {
    return {
      kaynak: 'musteriTahsilat',
      toplamTutar: tahsilat,
      durum: null,
      durumLabel: null,
      aciklama: 'Bakım müşteri tahsilat tutarı',
      satirlar: [],
      uyarilar: [],
      altEtiket: 'Müşteri tahsilatı',
    };
  }

  return {
    kaynak: null,
    toplamTutar: null,
    durum: null,
    durumLabel: null,
    aciklama: null,
    satirlar: [],
    uyarilar: [],
    altEtiket: null,
  };
}

export { BEDEL_DURUM_LABELS };
